import styles from '../cssModules/index.module.css';
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown, Form } from 'react-bootstrap';


export function CoordRepeat({ prod, setProdInfo, loginStatus }) {

    const apiURL = process.env.REACT_APP_SELLER;
    let jToken = localStorage.getItem('token');

    const fabric = ['Cotton', 'Denim', 'Fleece', 'Rayol', 'Chiffon', 'Wool', 'Art silk', 'Corduroy', 'Crepe', 'Down', 'Faux Fur', 'Fur', 'Georgette', 'Lenin', 'Modal',
        'Rayon', 'Satin', 'Silk', 'Synthetic', 'Velvet', 'Net', 'Rubber', 'Leather', 'Sequined', 'Khadi'
    ];

    const fitType = ['Regular', 'Loose', 'Relaxed', 'Semi', 'Athletic', 'Classic', 'Fitted', 'Modern', 'Oversized', 'Skinny', 'Slim',
        'Straight', 'Tailored'
    ];

    const color = ['red', 'green', 'blue', 'grey', 'white', 'black', 'brown', 'pink', 'orange', 'yellow', 'purple', 'gold', 'silver',
        'turquoise', 'whitesmoke'];

    const size = ['XS  (34 cm)', 'S (36 cm)', 'M (38 cm)', 'L (40 cm)', 'XL (42 cm)', '2XL (44 cm)', '3XL (46 cm)', '4XS (48 cm)', '5XL (50 cm)', '6XL (52 cm)', '7XL (54 cm)', '8XL (56 cm)', 'Free'];

    const itemLength = ['Above the Knee', 'Ankle Length', 'Below the Knee', 'Calf Length', 'Floor Length', 'High-Low', 'Knee-Length',
        'Maxi', 'Midi', 'Mini', 'Tea Length', 'Mid-Calf Length', 'Mid-Thigh Length'
    ]

    const kurtaStyle = ['A-Line', 'Anarkali', 'Angrakha', 'Empire', 'Empire', 'Empire', 'Straight', 'Wrap kurtas']

    const sleeve_size = ['Half Sleeve', 'Long Sleeve', 'Short Sleeve', 'Sleeveless', '3/4 Sleeve']

    const design = ['Solid', 'Striped', 'Graphic', 'Cartoon', 'Animal print', 'Argyle', 'Camouflage', 'Chequered', 'Floral', 'Galaxy', 'Geometric',
        'Hearts', 'Herringbone', 'Letter Print', 'Paisley', 'Plaid', 'Polka Dots', 'Tie Dye', 'Chevron', 'Fruits', 'Houndstooth', 'Letter print', 'Stars'
    ]

    const neckLine = ['Hooded Neck', 'Asymmetric Neck', 'Round Neck', 'Crew Neck', 'Boat Neck', 'Collared Neck', 'Cowl Neck',
        'Henley Neck', 'High Neck', 'Mandarin Neck', 'Mock Neck', 'Scoop Neck', 'Split Neck', 'Square Neck', 'Sweetheart Neck', 'Choker Neck',
        'Turtle Neck', 'V-Neck', 'U-Neck', 'Criss Cross Neck', 'Halter Neck', 'Keyhole Neck', 'Notch Neck', 'Off Shoulder Neck', 'One Shoulder Neck',
        'Sailor Collar Neck', 'Slit Neck', 'Tie Neck', 'Shawl Neck',
    ]

    const lifeStyle = ['Casual', 'Formal', 'Comfort', 'Business Casual', 'Evening']

    const closureType = ['Pull On', 'Button', 'Zipper', 'Snap', 'Buckle', 'Double Ring', 'Magnetic', 'Drawstring', 'Hook and Eye', 'Hook and Loop', 'Hook and Bar', 'Tie']

    const careInstruction = ['Machine Wash', 'Hand Wash Only', 'Dry Clean Only']

    const weaveMethod = ['Handloom', 'Powerloom']

    const includedComponent = ['Dupatta', 'Jacket', 'T-shirt', 'Coat', 'Koti', 'Shrug', 'None', 'Bottom wear']

    const collarStyle = ['Mandarin Collar', 'Band Collar', 'Notch Collar', 'Button Down Collar',
        'Point Collar', 'Shawl Collar', 'Spread Collar', 'Round collar', 'Wing Collar'
    ]

    const stock = ['In stock', 'Out of stock']

    const weightCat = ['Category 1 (upto 500 gm)', 'Category 2 (between 500 gm to 1 kg)', 'Category 3 (between 1 to 2 kg)']

    const [pht1, setpht1] = useState();
    const [pht2, setpht2] = useState();
    const [pht3, setpht3] = useState();
    const [pht4, setpht4] = useState();
    const [pht5, setpht5] = useState();

    const navigate = useNavigate();

    function checkFileSize(file) {
        if (file.size > 500000) {
            alert('File size should be less than 500 KB');
            return false;
        } else {
            return true;
        }
    }

    const ph1Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht1(e.target.files[0]);
    }
    const ph2Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht2(e.target.files[0]);
    }
    const ph3Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht3(e.target.files[0]);
    }
    const ph4Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht4(e.target.files[0]);
    }
    const ph5Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht5(e.target.files[0]);
    }

    function changeWeightCat(value) {
        switch (true) {
            case (value === 'Category 1 (upto 500 gm)'):
                return 1;
            case (value === 'Category 2 (between 500 gm to 1 kg)'):
                return 2;
            default:
                return 3;
        }
    }

    function changeWeightCatReverse(value) {
        switch (true) {
            case (Number(value) === 1):
                return 'Category 1 (upto 500 gm)';
            case ((Number(value)) === 2):
                return 'Category 2 (between 500 gm to 1 kg)';
            default:
                return 'Category 3 (between 1 to 2 kg)';
        }
    }

    const handleSubmit = async (e, msg) => {
        try {
            e.preventDefault();
            const images = [pht1, pht2, pht3, pht4, pht5];
            if (!(pht1 && pht2 && pht3 && pht4 && pht5)) return;

            const formData = new FormData();
            images.forEach((image) => {
                formData.append('images', image);
            });
            formData.append('product', JSON.stringify(prod));

            const response = await fetch(`${apiURL}/api/upload/image`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${jToken}` },
                body: formData,
                credentials: 'include'
            })

            if (response.status === 500) {
                throw new Error('Error while uploading product!');
            } else {

                if (response.status === 200) {
                    if (msg === 'repeat') {
                        // let data = await response.json();
                        // let prodId = data['prodId'];
                        alert('Product has been listed successfully!');
                        window.location.reload();
                    } else {
                        alert('Product has been listed successfully!');
                        window.location.reload();
                    }
                } else {
                    navigate('/error');
                }
            }
        } catch (error) {
            console.log(error.message);
            await loginStatus();
            navigate('/login');
        }
    }

    const toggleSelection = (size, stock) => {
        try {
            let newArr;
            // prod = { 'additionSize': { 'XL': 20, 'xxl': 24, 'L': 10 } }
            if (stock) {
                // This will handle the situatioin when user already has size previously or not
                newArr = { ...prod['additionsize'], [size]: Number(stock) };
                setProdInfo(prev => {
                    return { ...prev, "additionsize": newArr }
                });
            } else {
                if (Object.keys(prod['additionsize']).includes(size)) {
                    newArr = Object.fromEntries(
                        Object.entries(prod['additionsize']).filter(([key]) => {
                            return key !== size;
                        })
                    )
                    setProdInfo(prev => {
                        return { ...prev, "additionsize": newArr }
                    })
                } else {
                    newArr = { ...prod["additionsize"], [size]: null }
                    setProdInfo(prev => {
                        return { ...prev, "additionsize": newArr }
                    })
                }
            }
        } catch (error) {
            console.log(error.message);
        }
    };

    return (
        <>
            {prod.additionsize &&
                (<div className={`${styles.sellerUploadmainDiv}`}>
                    <form id='uploadForm' onSubmit={(e) => handleSubmit(e, 'form')} className={`${styles.sellerUploadForm}`}>
                        <div className={`${styles.sellerUploadDiv}`}>
                            <div className={`${styles.sellerUploadPhotoSecDiv}`}>
                                <div className={`${styles.sellerUploadPhotoInput}`}>

                                    <label for='ph1'>
                                        Choose photo 1
                                    </label>
                                    <input id='ph1' type='file' onChange={ph1Upload} required={true} accept='image/*' />
                                </div>
                                <div className={`${styles.sellerUploadPhotoInput}`}>

                                    <label for='ph2'>
                                        Choose photo 2
                                    </label>
                                    <input id='ph2' type='file' onChange={ph2Upload} required={true} accept='image/*' />
                                </div>
                                <div className={`${styles.sellerUploadPhotoInput}`}>

                                    <label for='ph3'>
                                        Choose photo 3
                                    </label>
                                    <input id='ph3' type='file' onChange={ph3Upload} required={true} accept='image/*' />
                                </div>
                                <div className={`${styles.sellerUploadPhotoInput}`}>

                                    <label for='ph4'>
                                        Choose photo 4
                                    </label>
                                    <input id='ph4' type='file' onChange={ph4Upload} required={true} accept='image/*' />
                                </div>
                                <div className={`${styles.sellerUploadPhotoInput}`}>

                                    <label for='ph5'>
                                        Choose photo 5
                                    </label>
                                    <input id='ph5' type='file' onChange={ph5Upload} required={true} accept='image/*' />
                                </div>
                            </div>
                            <div className={`${styles.selleruploadFormDiv}`}>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='fabric'>
                                        Fabric
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='fabric' name='fabric' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.fabric} selected hidden>{prod.fabric}</option>
                                        {fabric.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='color'>
                                        Color
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='color' name='color' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.color} selected hidden>{prod.color}</option>
                                        {color.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                {/* <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='size'>
                                        Size
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='size' name='size' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.size} selected hidden>{prod.size}</option>
                                        {size.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div> */}

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='sleeve_size'>
                                        Sleeve size
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='sleeve_size' required name='sleeve_size' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.sleeve_size} selected hidden>{prod.sleeve_size}</option>
                                        {sleeve_size.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='closureType'>
                                        Closure type
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='closureType' required name='closureType' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.closureType} selected hidden>{prod.closureType}</option>
                                        {closureType.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='fitType'>
                                        Fit type
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='fitType' required name='fitType' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.fitType} selected hidden>{prod.fitType}</option>
                                        {fitType.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='itemLength'>
                                        Item length
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='itemLength' required name='itemLength' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.itemLength} selected hidden>{prod.itemLength}</option>
                                        {itemLength.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='kurtaStyle'>
                                        Kurta style
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='kurtaStyle' required name='kurtaStyle' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.kurtaStyle} selected hidden>{prod.kurtaStyle}</option>
                                        {kurtaStyle.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='weaveMethod'>
                                        Weave method
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='weaveMethod' required name='weaveMethod' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.weaveMethod} selected hidden>{prod.weaveMethod}</option>
                                        {weaveMethod.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='neckLine'>
                                        Neck line
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='neckLine' required name='neckLine' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.neckLine} selected hidden>{prod.neckLine}</option>
                                        {neckLine.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='collarStyle'>
                                        Collar style
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='collarStyle' required name='collarStyle' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.collarStyle} selected hidden>{prod.collarStyle}</option>
                                        {collarStyle.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='includedComponent'>
                                        Included component
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='includedComponent' required name='includedComponent' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.includedComponent} selected hidden>{prod.includedComponent}</option>
                                        {includedComponent.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='lifeStyle'>
                                        Life style
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='lifeStyle' required name='lifeStyle' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.lifeStyle} selected hidden>{prod.lifeStyle}</option>
                                        {lifeStyle.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='careInstruction'>
                                        Care instruction
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='careInstruction' required name='careInstruction' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.careInstruction} selected hidden>{prod.careInstruction}</option>
                                        {careInstruction.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='design'>
                                        Design
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='design' required name='design' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.design} selected hidden>{prod.design}</option>
                                        {design.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='stock'>
                                        Stock
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='stock' required name='active' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.active} selected hidden>{prod.active}</option>
                                        {stock.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='weightCat'>
                                        Weight category (Courier ready)
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='weightCat' required name='weightCat' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.weightCat} selected hidden>{changeWeightCatReverse(prod.weightCat)}</option>
                                        {weightCat.map(item => {
                                            return (
                                                <>
                                                    <option value={changeWeightCat(item)}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='name'>
                                        Name
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='name'
                                        onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })}
                                        required
                                        defaultValue={prod.name}
                                        type='text' placeholder="Name of the product" name='name' />
                                </div>
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='oldPrice'>
                                        Price
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`}
                                        id='oldPrice'
                                        onChange={(e) =>
                                            setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })}
                                        required={true}
                                        type='number'
                                        defaultValue={prod.oldPrice}
                                        placeholder="price"
                                        name='oldPrice' />
                                </div>
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='currentPrice'>
                                        Discount Price
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='currentPrice'
                                        onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })}
                                        required={true} type='number' placeholder="This price will be highlighted"
                                        defaultValue={prod.currentPrice}
                                        name='currentPrice' />
                                </div>
                                {/* <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='stock'>
                                        In stock
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='stock'
                                        onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })}
                                        required={true} type='number'
                                        defaultValue={prod.stock}
                                        placeholder="Total stock available" name='stock' />
                                </div> */}
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="primary">Sizes</Dropdown.Toggle>
                                        <Dropdown.Menu
                                        // bsPrefix={`form-control, ${styles.dropdownMenu}`}
                                        >
                                            {size.map((option, idx) => (
                                                <>
                                                    <div className={`${styles.formControlDiv}`}>
                                                        <div style={{ flexBasis: '50%', fontSize: '13px' }}>
                                                            <Form.Check
                                                                key={idx}
                                                                type="checkbox"
                                                                label={option}
                                                                checked={Object.keys(prod['additionsize']).includes(option)}
                                                                onChange={() => toggleSelection(option, null, 'additionsize')}
                                                                className="px-3"
                                                            />
                                                        </div>
                                                        <div style={{ flexBasis: '50%' }}>
                                                            <Form.Control
                                                                type='number'
                                                                placeholder='Stock'
                                                                key={idx}
                                                                value={prod['additionsize'][option] ? prod['additionsize'][option] : null}
                                                                onChange={(e) => toggleSelection(option, e.target.value, 'additionsize')}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='sku'>
                                        Stock keeping unit
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='sku' defaultValue={prod.sku}
                                        onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })}
                                        required={true}
                                        type='text'
                                        placeholder="SKU"
                                        name='sku' />
                                </div>
                            </div>
                        </div>
                        <input type="submit" value='UPLOAD' className={`${styles.sellerUploadBtn}`} />
                        <button className={`${styles.uploadRepeat}`}
                            onClick={(e) => { handleSubmit(e, 'repeat') }}>Upload & Repeat</button>
                    </form >
                </div >)
            }
        </>
    )
}